import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  HostListener,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription, filter, take } from 'rxjs';
import { SidebarBottomSectionComponent } from '../sidebar-bottom-section/sidebar-bottom-section.component';
import { HasPermissionDirective } from '../../directives/has-permission.directive';
import { Permissions } from '../../../core/constants/permissions'; 
import { HasRoleDirective } from '../../directives/has-role.directive';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    HasPermissionDirective,
    HasRoleDirective,
    CommonModule,
    RouterModule,
    TranslateModule,
    SidebarBottomSectionComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Output() sidebarClosed = new EventEmitter<void>();
  @Input() isSidebarOpen: boolean = false;
  @ViewChild('settingsMenu') settingsMenu!: ElementRef;
  @ViewChild('appInfoMenu') appInfoMenu!: ElementRef;
 Permissions = Permissions;
  isRtl: boolean = false;
  private sub = new Subscription();
  isSettingsMenuOpen: boolean = false;
  isAppInfoMenuOpen = false;

  constructor(public languageService: LanguageService, public router: Router) {}

  ngOnInit(): void {
    this.sub.add(
      this.languageService.rtl$.subscribe((rtl) => {
        this.isRtl = rtl;
      })
    );


  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (
      !this.settingsMenu?.nativeElement.contains(event.target) &&
      !this.appInfoMenu?.nativeElement.contains(event.target)
    ) {
      this.closeAllSubmenus();
    }
  
  }

  toggleAppInfoMenu() {
    this.isAppInfoMenuOpen = !this.isAppInfoMenuOpen;
    this.isSettingsMenuOpen = false;
  }

  toggleSettingsMenu() {
    this.isSettingsMenuOpen = !this.isSettingsMenuOpen;
    this.isAppInfoMenuOpen = false;
  }

  closeAllSubmenus() {
    this.isSettingsMenuOpen = false;
    this.isAppInfoMenuOpen = false;
  }

onCloseSidebar() {
  if(this.isSidebarOpen){
    // this.closeAllSubmenus();
   this.sidebarClosed.emit();
  }

}

  isActiveRoute(path: string): boolean {
    return this.router.url === path;
  }

  isStartsWithRoute(prefix: string): boolean {
    return this.router.url.startsWith(prefix);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}